// extracted by mini-css-extract-plugin
export default {"divider":"Divider__divider___idW6"};